<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="content">
  <div class="title">请加入以下团队</div>
  <mat-spinner
    [diameter]="64"
    *ngIf="loading"
    style="margin: 20px auto"
  ></mat-spinner>
  <div class="list">
    <div class="item" *ngFor="let item of teams">{{ item.name }}</div>
  </div>
  <div class="txt">登录账户时，</div>
  <div class="txt">出现以上任意一个团队加入即可使用</div>
  <div class="btn" (click)="close()">知道了</div>
</div>
